import { Container } from "../Container/Container";

export class Box extends Container {
    protected createSelf() {
        super.createSelf();
        this.addClass("box");
    }
}
